import {
  PRODUCT_OPTIONS_MODAL_MIN_HEIGHT,
  PRODUCT_OPTIONS_MODAL_WIDTH,
} from '@Constants/LeftDrawer';
import useCheckoutPresenter from '@Screens/Checkout/presenter';
import OwnableTheme from '@Theme';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Hoverable } from 'react-native-web-hooks';
import styled from 'styled-components/native';

import { useProductsStore } from '~stores/products';

const Wrapper = styled.View<{ position: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  width: ${
    // @ts-expect-error
    PRODUCT_OPTIONS_MODAL_WIDTH
  }px;
  min-height: ${PRODUCT_OPTIONS_MODAL_MIN_HEIGHT}px;
  padding-top: 50px;
  padding-bottom: 20px;
  ${({
    // @ts-expect-error
    position,
  }) => position}
`;

const Title = styled.Text`
  font-size: 22px;
  font-weight: 700;
  font-family: ${OwnableTheme.fonts.gilroy.regular};
  line-height: 27px;
  color: black;
  letter-spacing: 0.03em;
  margin-bottom: 20px;
`;

const OptionValueWrapper = styled.Pressable<{ isHovered?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 286px;
  height: 47px;
  border-radius: 15px;
  border: 1.5px solid black;
  margin-bottom: 20px;
  ${({ isHovered }) => isHovered && `background-color: #ECECEC`};
`;

const OptionValue = styled.Text`
  font-size: 16px;
  font-weight: 600;
  font-family: ${OwnableTheme.fonts.gilroy.regular};
  line-height: 19px;
  color: black;
`;

const ProductOptionModal = () => {
  const { selectProductOption, modalPositions } = useCheckoutPresenter();
  const { currentProduct } = useProductsStore();
  const optionTitle = currentProduct?.options?.[0]?.optionName;
  return (
    <Wrapper position={modalPositions}>
      <Title>Product Option {optionTitle ? `<${optionTitle}>` : ''}</Title>
      {currentProduct?.options?.map((option) => (
        <Hoverable>
          {(isHovered) => (
            <OptionValueWrapper
              onPress={() => {
                selectProductOption(option);
              }}
              isHovered={isHovered}
            >
              <OptionValue>
                {option?.valueName ?? option?.optionName}
              </OptionValue>
            </OptionValueWrapper>
          )}
        </Hoverable>
      ))}
    </Wrapper>
  );
};

export default observer(ProductOptionModal);
